// Coucou nav — ported from webflow-export/js/nav.js
(function () {
  'use strict';

  function debounce(fn, delay) {
    var timer;
    return function () { clearTimeout(timer); timer = setTimeout(fn, delay); };
  }

  // ── Header height ───────────────────────────────────────────────────────
  function updateHeaderHeight() {
    var nav = document.querySelector('.nav');
    if (!nav) return;
    var h = nav.offsetHeight;
    document.body.style.setProperty('--header-height', h + 'px');
    document.body.style.setProperty('--header-group-height', h + 'px');
    document.body.style.setProperty('--transparent-header-offset-boolean', '0');
  }

  // ── Scroll: is-active (white bg) / is-scrolled (hide on fast scroll) ───
  function initScrollBehavior() {
    var nav = document.querySelector('.nav');
    if (!nav) return;
    var OFFSET_Y = 20;
    var SCROLL_THRESHOLD = 1000;
    var oldScroll = 0;

    function update() {
      var y = window.scrollY;
      nav.classList.toggle('is-active', y > OFFSET_Y);
      var shouldHide = y > SCROLL_THRESHOLD && y > oldScroll && nav.classList.contains('is-active');
      nav.classList.toggle('is-scrolled', shouldHide);
      oldScroll = y;
    }

    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  // ── Mobile menu ─────────────────────────────────────────────────────────
  function initMobileMenu() {
    var btn = document.querySelector('[data-menu-button]');
    var nav = document.querySelector('[data-menu-status]');
    if (!btn || !nav) return;

    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', 'coucou-mobile-nav');
    nav.setAttribute('id', 'coucou-mobile-nav');
    nav.setAttribute('role', 'navigation');
    nav.setAttribute('aria-label', 'Main navigation');

    if (!btn._mobileClick) {
      btn._mobileClick = true;
      btn.addEventListener('click', function () {
        var isOpen = nav.dataset.menuStatus === 'open';
        nav.dataset.menuStatus = isOpen ? 'closed' : 'open';
        btn.setAttribute('aria-expanded', String(!isOpen));
      });
    }

    document.querySelectorAll('[data-dropdown-toggle]').forEach(function (toggle, i) {
      var dropdown = toggle.nextElementSibling;
      if (!dropdown || !dropdown.classList.contains('nav-dropdown') || toggle._mobileInit) return;
      toggle._mobileInit = true;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-haspopup', 'true');
      toggle.setAttribute('aria-controls', 'coucou-dropdown-' + i);
      dropdown.setAttribute('id', 'coucou-dropdown-' + i);
      dropdown.setAttribute('role', 'menu');
      toggle.addEventListener('click', function () {
        var isOpen = toggle.dataset.dropdownToggle === 'open';
        document.querySelectorAll('[data-dropdown-toggle]').forEach(function (other) {
          if (other !== toggle) { other.dataset.dropdownToggle = 'closed'; other.setAttribute('aria-expanded', 'false'); }
        });
        toggle.dataset.dropdownToggle = isOpen ? 'closed' : 'open';
        toggle.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  }

  // ── Desktop dropdowns ───────────────────────────────────────────────────
  function initDesktopDropdowns() {
    var toggles = document.querySelectorAll('[data-dropdown-toggle]');
    toggles.forEach(function (toggle, i) {
      var dropdown = toggle.nextElementSibling;
      if (!dropdown || !dropdown.classList.contains('nav-dropdown') || toggle._desktopInit) return;
      toggle._desktopInit = true;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-haspopup', 'true');
      toggle.setAttribute('aria-controls', 'coucou-desktop-dropdown-' + i);
      dropdown.setAttribute('id', 'coucou-desktop-dropdown-' + i);
      dropdown.setAttribute('role', 'menu');
      dropdown.setAttribute('aria-hidden', 'true');

      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        var isOpen = toggle.dataset.dropdownToggle === 'open';
        toggles.forEach(function (other) {
          if (other !== toggle) {
            other.dataset.dropdownToggle = 'closed';
            other.setAttribute('aria-expanded', 'false');
            var od = other.nextElementSibling;
            if (od) od.setAttribute('aria-hidden', 'true');
          }
        });
        toggle.dataset.dropdownToggle = isOpen ? 'closed' : 'open';
        toggle.setAttribute('aria-expanded', String(!isOpen));
        dropdown.setAttribute('aria-hidden', String(isOpen));
        if (!isOpen) { var fl = dropdown.querySelector('a[href]'); if (fl) fl.focus(); }
      });

      toggle.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { closeDropdown(toggle, dropdown); toggle.focus(); }
      });

      dropdown.addEventListener('keydown', function (e) {
        var items = Array.from(dropdown.querySelectorAll('a[href]'));
        var idx = items.indexOf(document.activeElement);
        if (e.key === 'ArrowDown') { e.preventDefault(); items[(idx + 1) % items.length].focus(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); items[(idx - 1 + items.length) % items.length].focus(); }
        else if (e.key === 'Escape') { e.preventDefault(); closeDropdown(toggle, dropdown); toggle.focus(); }
      });
    });

    document.addEventListener('click', function (e) {
      var inside = Array.from(toggles).some(function (t) {
        var d = t.nextElementSibling;
        return t.contains(e.target) || (d && d.contains(e.target));
      });
      if (!inside) toggles.forEach(function (t) { closeDropdown(t, t.nextElementSibling); });
    });
  }

  function closeDropdown(toggle, dropdown) {
    toggle.dataset.dropdownToggle = 'closed';
    toggle.setAttribute('aria-expanded', 'false');
    if (dropdown) dropdown.setAttribute('aria-hidden', 'true');
  }

  // ── Init navigation (mobile vs desktop) ────────────────────────────────
  function initNavigation() {
    if (!initNavigation._resizeWired) {
      initNavigation._resizeWired = true;
      window.addEventListener('resize', debounce(function () {
        updateHeaderHeight();
        initNavigation._lastMode = null;
        initNavigation();
      }, 200));
    }
    var mobile = window.innerWidth < 768;
    if (mobile && initNavigation._lastMode !== 'mobile') {
      initMobileMenu(); initNavigation._lastMode = 'mobile';
    } else if (!mobile && initNavigation._lastMode !== 'desktop') {
      initDesktopDropdowns(); initNavigation._lastMode = 'desktop';
    }
  }

  // ── Cart: proxy our styled button → Horizon's cart drawer trigger ───────
  function initCartButton() {
    var btn = document.querySelector('.coucou-cart-open');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
      if (trigger) {
        trigger.click();
      } else {
        window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
      }
    });
  }

  // ── Page-type setup ──────────────────────────────────────────────────────
  // Overlay pages have a full-bleed dark hero behind the nav (transparent white
  // text like Webflow). All other pages start with orange text and get
  // padding-top so content starts below the fixed nav.
  var OVERLAY_PREFIXES = ['/', '/pages/about', '/pages/welcome', '/metaobjects/drop'];

  function isOverlayPath(path) {
    if (path === '/') return true;
    return OVERLAY_PREFIXES.some(function (p) {
      return p !== '/' && (path === p || path.indexOf(p + '/') === 0);
    });
  }

  function initPageType() {
    var main = document.querySelector('#MainContent');
    var nav = document.querySelector('.nav');
    if (!main || !nav) return;
    var path = window.location.pathname;
    if (isOverlayPath(path)) {
      document.body.classList.add('nav-overlay');
    } else {
      main.style.paddingTop = nav.offsetHeight + 'px';
      window.addEventListener('resize', debounce(function () {
        var n = document.querySelector('.nav');
        if (n) main.style.paddingTop = n.offsetHeight + 'px';
      }, 200));
    }
  }

  // ── Cart count: keep [data-coucou-cart-count] in sync after add/update ──
  // cart:update fires from product-form-component (itemCount = qty added) and
  // cart-items-component (itemCount = true total). Mirror Horizon's CartIcon
  // logic: add to current for PDP adds, replace otherwise.
  function initCartCount() {
    document.addEventListener('cart:update', function (event) {
      var el = document.querySelector('[data-coucou-cart-count]');
      if (!el) return;
      var detail = (event.detail && event.detail.data) || {};
      var added = parseInt(detail.itemCount, 10) || 0;
      var fromPDP = detail.source === 'product-form-component';
      if (fromPDP) {
        el.textContent = (parseInt(el.textContent, 10) || 0) + added;
      } else {
        el.textContent = added;
      }
    });
  }

  // ── Boot ────────────────────────────────────────────────────────────────
  updateHeaderHeight();
  initPageType();
  initNavigation();
  initScrollBehavior();
  initCartButton();
  initCartCount();
  // Re-check scroll after browser settles — catches #hash navigations
  setTimeout(function () { window.dispatchEvent(new Event('scroll')); }, 50);
  window.addEventListener('resize', debounce(updateHeaderHeight, 200));
})();
